/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Alpha_DescriptionInputs */

const en_landing_capability_alpha_description = /** @type {(inputs: Landing_Capability_Alpha_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert static research PDFs into secure, AI-ready data that any internal or external agent can query, giving the front office instant access to proprietary alpha.`)
};

/**
* | output |
* | --- |
* | "Convert static research PDFs into secure, AI-ready data that any internal or external agent can query, giving the front office instant access to proprietary ..." |
*
* @param {Landing_Capability_Alpha_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_alpha_description = /** @type {((inputs?: Landing_Capability_Alpha_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Alpha_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_alpha_description(inputs)
});